// extracted by css-extract-rspack-plugin
var _1 = "UWKUc";
var _2 = "iZbPU";
var _3 = "IjQyD";
var _4 = "epBmH";
export { _1 as "baseMailListItemColor", _2 as "flaggedMailListItemColor", _3 as "regularMailListItemColor", _4 as "selectedMailListItemColor" }
